import React from "react";
import { Module } from "../../components";

import {
  CoberturasAssistenciasPage,
  CondicoesGeraisPage,
  DuvidasFrequentesPage,
  ResultadoSorteiosPage,
  SorteiosHabitacionalTradicionalPage,
  SorteiosHabitacionalMaisPage,
  SorteiosHabitacionalMaisPremiavelPage,
  SorteiosHabitacionalLarMaisPremiavelPage,
  ChooseCoverageToActivate,
  MaisPage,
  MaisPremiavelPage,
  TradicionalPage,
  TrackingStatusPage,
} from "./pages";
import HomeHabitation from "./pages/Home";

const Habitacional = () => {
  return (
    <Module
      moduleName="Seguro Habitacional"
      description="Uma página para você, cliente, saber mais sobre suas assistências, coberturas, resultados de sorteios e outras dúvidas."
    >
      <Module.Page
        path="/coberturas-e-assistencias"
        page={CoberturasAssistenciasPage}
        title="Coberturas e assistências"
        description="Veja quais e como funcionam as coberturas e assistências do seu Seguro Habitacional."
      />
      <Module.Page
        path="/duvidas-frequentes"
        page={DuvidasFrequentesPage}
        title="Dúvidas frequentes"
        description="Separamos algumas dúvidas e questionamentos mais comuns que nossos clientes fazem."
      />
      <Module.Page
        path="/condicoes-gerais"
        page={CondicoesGeraisPage}
        title="Condições Gerais"
        description="Baixe as condições gerais do seu produto."
      />
      <Module.Page
        path="/resultados-dos-sorteios/seguro-habitacional-lar-mais-premiavel"
        page={SorteiosHabitacionalLarMaisPremiavelPage}
        title="Seguro Habitacional Mais"
        parentPage="/resultados-dos-sorteios"
        disableNavigation
      />
      <Module.Page
        path="/resultados-dos-sorteios/seguro-habitacional-mais-premiavel"
        page={SorteiosHabitacionalMaisPremiavelPage}
        title="Seguro Habitacional Mais Premiável"
        parentPage="/resultados-dos-sorteios"
        disableNavigation
      />
      <Module.Page
        path="/resultados-dos-sorteios/seguro-habitacional-mais"
        page={SorteiosHabitacionalMaisPage}
        title="Seguro Habitacional Mais"
        parentPage="/resultados-dos-sorteios"
        disableNavigation
      />
      <Module.Page
        path="/resultados-dos-sorteios/seguro-habitacional-tradicional"
        page={SorteiosHabitacionalTradicionalPage}
        title="Seguro Habitacional Tradicional"
        parentPage="/resultados-dos-sorteios"
        disableNavigation
      />
      <Module.Page
        path="/resultados-dos-sorteios"
        page={ResultadoSorteiosPage}
        title="Resultados dos sorteios"
        description="Consulte os últimos resultados dos sorteios e boa sorte!"
      />
      <Module.Page
        path="/acionar_sinistro"
        page={ChooseCoverageToActivate}
        description="Como Funciona o Sinistro"
      />
      <Module.Page
        path="/"
        page={HomeHabitation}
        title="Página Seguro Habitacional"
      />
      <Module.Page
        path="/seguro-habitacional-tradicional"
        page={TradicionalPage}
        title="Página Seguro Habitacional Tradicional"
      />
      <Module.Page
        path="/seguro-habitacional-mais"
        page={MaisPage}
        title="Página Seguro Habitacional Mais"
      />
      <Module.Page
        path="/seguro-habitacional-mais-premiavel"
        page={MaisPremiavelPage}
        title="Página Seguro Habitacional Mais Premiável"
      />
      <Module.Page
        path="/acompanhar-pedidos/:query"
        page={TrackingStatusPage}
        title="Página Seguro Habitacional Mais Premiável"
      />
    </Module>
  );
};

Habitacional.propTypes = {};

export default Habitacional;
